import React, { createContext, useContext, useState, useEffect } from "react";
import {
  // getAllPaymentMethods,
  getAllPlans,
  getCurrentPlan,
  getNextBilling,
  getPaymentCardInfo,
} from "../services/billing";

const BillingContext = createContext();

export const BillingProvider = ({ children }) => {
  const [data, setData] = useState({
    plans: [],
    paymentMethods: [],
    currentPlan: null,
    nextBilling: null,
  });

  const [loading, setLoading] = useState({
    plans: true,
    paymentMethods: true,
    currentPlan: true,
    nextBilling: true,
  });

  const [error, setError] = useState({
    plans: null,
    paymentMethods: null,
    currentPlan: null,
    nextBilling: null,
  });

  const fetchBillingData = async () => {
    const [ plansRes, currentPlanRes, nextBillingRes] =
      await Promise.allSettled([
        getAllPlans(),
        getCurrentPlan(),
        getNextBilling()
      ]);
    const currentPlan =
      currentPlanRes?.status === "fulfilled"
        ? currentPlanRes?.value?.data?.data?.attributes
        : null;

    // Step 2: Determine if plan is free
    const isFreePlan =!currentPlan || currentPlan?.price === 0 || currentPlan?.price === "Free";

    // Step 3: Conditionally fetch payment info only for paid plans
    let paymentRes = { status: "skipped" }; 
    if (!isFreePlan) {
      try {
        paymentRes = await getPaymentCardInfo();
        setData((prev) => ({ ...prev, paymentMethods: paymentRes?.data }));
      } catch (err) {
        paymentRes = { error: err?.message || "Failed to load payment info" };
      }
    }
    setData((prev) => ({
      ...prev,
      plans:
        plansRes?.status === "fulfilled"
          ? plansRes?.value?.data?.data
          : prev?.plans,
      paymentMethods:
        paymentRes?.status === "fulfilled"
          ? paymentRes?.value?.data?.payment_methods
          : prev.paymentMethods,
      currentPlan:
        currentPlanRes?.status === "fulfilled"
          ? currentPlanRes?.value?.data?.data?.attributes
          : prev?.currentPlan,
      nextBilling: nextBillingRes?.status === "fulfilled"
        ? nextBillingRes?.value?.data
        : prev?.nextBilling
    }));

    setError((prev) => ({
      ...prev,
      plans:
        plansRes.status === "rejected"
          ? plansRes.reason?.message || "Failed to load plans"
          : null,
      paymentMethods:
        paymentRes.status === "rejected"
          ? paymentRes.reason?.message || "Failed to load payment methods"
          : null,
      currentPlan:
        currentPlanRes.status === "rejected"
          ? currentPlanRes.reason?.message || "Failed to load current plan"
          : null,
      nextBilling:
        nextBillingRes.status === "rejected"
          ? nextBillingRes.reason?.message || "Failed to load current plan"
          : null,
    }));

    setLoading((prev) => ({
      ...prev,
      plans: false,
      paymentMethods: false,
      currentPlan: false,
      nextBilling: false
    }));
  };

  const fetchPaymentMethods = async () => {
    setLoading((prev) => ({ ...prev, paymentMethods: true }));
    try {
      const res = await getPaymentCardInfo();
      setData((prev) => ({ ...prev, paymentMethods: res.data }));
    } catch (err) {
      setError((prev) => ({
        ...prev,
        paymentMethods: err?.message || "Failed to load payment methods",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, paymentMethods: false }));
    }
  };

  useEffect(() => {
    fetchBillingData();
  }, []);

  return (
    <BillingContext.Provider
      value={{
        ...data,
        loading,
        error,
        refetchBilling: fetchBillingData,
        refetchPaymentMethods: fetchPaymentMethods,
      }}
    >
      {children}
    </BillingContext.Provider>
  );
};

export const useBilling = () => useContext(BillingContext);